import { Box, Modal, Typography, useTheme } from '@mui/material'
import React from 'react'
import { CustomeModalButton } from '../../../lib/formik/NewFormInputs'
import { CartDialogIcon } from '../../../assets/SvgIcons'

type Props = {
    open: boolean
    setClose: React.Dispatch<React.SetStateAction<boolean>>
    isLoading?: boolean
    handleSuccess: () => void
}

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '100%',
    maxWidth: '533px',
    bgcolor: 'background.paper',
    // border: '2px solid #000',
    boxShadow: 24,
    borderRadius: '12px',
    p: '24px',
    ':focus': {
        outline: 'none'
    }
}

function AddtoCardPopup(props: Props) {
    const { open, setClose, isLoading, handleSuccess } = props
    const { palette } = useTheme()

    const handleClose = () => {
        setClose(false)
    }

    return (
        <Modal
            open={open}
            onClose={handleClose}
            // aria-labelledby={title}
            aria-describedby={'form-modal'}
        >
            <Box
                sx={style}>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}><CartDialogIcon /></Box>
                <Typography mt={'12px'} textAlign={'center'} variant='h1' color={palette.text.primary}>Added to Cart Successfully!</Typography>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px', mt: '48px' }}>
                    <CustomeModalButton lookType={'outlined'} btnText={'Cancel'} onClick={() => handleClose()} boxStyle={{ borderRadius: '4px' }} />
                    <CustomeModalButton lookType={'contained'} btnText={'Go to Cart'} onClick={() => handleSuccess()} isLoading={isLoading} boxStyle={{ borderRadius: '4px' }} />
                </Box>
            </Box>
        </Modal >
    )
}

export default AddtoCardPopup